import axiosInstance from './axios/axiosConfig'
import { endpoints } from './axios/endpoints'
import ScheduledSendService from './scheduledSendService'

// The page shows each of these answers itself (the event card, the scheduled
// sends list, its own toast), so the shared success and error toasts are off.
// A 401 still signs the user out through the axios interceptor.
const quiet = { silentToast: true, silentErrorToast: true }

/** The Bulk Send page's reads and its cancel. */
const BulkSendService = {
    /**
     * What an event needs: `{absolute_time, niceness, comm, others}` of its
     * active pipelines (read with helpers/bulkSend `eventDetailsFrom`). 404
     * when it has no active pipeline or a pipeline's template is missing.
     */
    eventDetails: (eventType) =>
        axiosInstance.get(endpoints.eventTypeDetails, {
            params: { event_type: eventType },
            ...quiet,
        }),

    /** The event's sends still to go out (shared with the pipeline delete check). */
    scheduledSends: ScheduledSendService.list,

    /** Stop one scheduled send by its event id: `{event_id, event_type}`. */
    cancelScheduledSend: ScheduledSendService.cancel,
}

export default BulkSendService
